<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <!-- <el-select-tree
        v-model="query.deptID"
        url="SystemApplication/Dept/DeptTree"
        node-key="fDeptID"
        panel-width="300px"
        clearable
        size="small"
      /> -->
      <el-input
        v-model="query.user"
        placeholder="用户帐号或名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-select
        v-model="query.userType"
        placeholder="帐号类型"
        style="width: 150px"
        size="small"
        clearable
      >
        <el-option value="超级管理员">超级管理员</el-option>
        <el-option value="管理员">管理员</el-option>
        <el-option value="普通用户" />
        <el-option value="经销商">经销商</el-option>
      </el-select>
      <el-select
        v-model="query.logType"
        placeholder="日志类型"
        style="width: 100px"
        size="small"
        clearable
      >
        <el-option value="安全日志">安全日志</el-option>
        <el-option value="操作日志">操作日志</el-option>
      </el-select>
      <el-input
        v-model="query.modularName"
        placeholder="模块"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-select
        v-model="query.fOperationType"
        placeholder="操作类型"
        style="width: 100px"
        size="small"
        clearable
      >
        <el-option value="新增">新增</el-option>
        <el-option value="修改">修改</el-option>
        <el-option value="删除">删除</el-option>
        <el-option value="审批">审批</el-option>
        <el-option value="查询">查询</el-option>
        <el-option value="导出">导出</el-option>
        <el-option value="其它">其它</el-option>
      </el-select>
      <el-date-picker
        v-model="query.startDate"
        type="date"
        placeholder="起始日期"
        value-format="yyyy-MM-dd"
        size="small"
        style="width: 130px"
      />
      <el-date-picker
        v-model="query.endDate"
        type="date"
        placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="small"
        style="width: 130px"
      />

      <el-input
        v-model="query.describe"
        placeholder="详情描述"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-popover v-model="visible" placement="bottom" width="" trigger="click">
        <el-date-picker
          v-model="selectDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          size="small"
        />

        <div style="text-align: right; margin: 10px 0">
          <el-button size="mini" type="text" @click="visible = false">取消</el-button>
          <el-button type="primary" size="mini" @click="_delete">确定</el-button>

        </div>

        <el-button v-if="delState" slot="reference" size="small">删除</el-button>
      </el-popover>
      <el-button-export v-if="exportState" :url="downloadUrl">导出</el-button-export>
    </div>
    <!-- 列表---------------------------- -->
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        style="max-height: 100%"
        @select="rowSelect"
        @select-all="rowSelect"
      >
        <!-- <el-table-column type="selection" width="55" /> -->
        <el-table-column prop="userNumber" label="用户帐号" />
        <el-table-column prop="userName" label="用户名" />
        <el-table-column prop="userType" label="帐号类型" />
        <el-table-column prop="fIp" label="客户端IP" />
        <el-table-column prop="fType" label="日志类型" />
        <el-table-column prop="fModular" label="模块" />
        <el-table-column prop="fDate" label="时间" :formatter="dateFormat" />
        <el-table-column prop="fOperationType" label="操作类型" />
        <el-table-column prop="describe" label="详情描述" />
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import ConfirmButton from '@components/ConfirmButton'

// import EditForm from './EditForm'

export default {
  components: {
    // EditForm
    ConfirmButton
  },
  data() {
    return {
      query: {
        user: null,
        userType: null,
        logType: null,
        modularName: null,
        fOperationType: null,
        startDate: null,
        endDate: null,
        describe: null,

        pageIndex: 1,
        pageSize: 20
      },
      selectDate: '',
      visible: false,
      pageRecordTotal: 0,
      tableData: [],
      loading: false,
      currentEditItems: null,
      exportState: true,
      delState: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '001005002') {
        this.exportState = val.isGrant
      }
      if (val.key == '001005003') {
        this.delState = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('SystemApplication/Log/LogEntry', this.query).then(
        (res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }

          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        }
      )
        .finally(() => this.loading = false)
    },

    _delete() {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delUser(this.selectDate)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    delUser(dateId) {
      return this.$httpPost(`SystemApplication/Log/DeleteLog`, {
        fDate: dateId
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    rowSelect: function(selction) {
      // console.log('rowSelect', selction)
      // console.log("currentEditItems", currentEditItems);
      // this.currentEditItems = selction;
    },

    // 导出日志
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/LogDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        // if (rtn.startGroupNumber == "") rtn.startGroupNumber = null;
        // if (rtn.endGroupNumber == "") rtn.endGroupNumber = null;
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    },
    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
